<template>
    <div class="event"
        :class="{'disabled': is_disabled}"
        v-if="parsed_notification.target">
        <div class="label" v-if="is_disabled">
            <i class="loading cog icon" v-if="notification.data.status == 'processing'"></i>
            <i class="bell slash icon" v-if="notification.data.status == 'processed'"></i>
            <i class="red cancel icon" v-if="notification.data.status == 'failure'"></i>
        </div>
        <div class="label" v-else>
            <i class="loading cog icon" v-if="notification.data.status == 'processing'"></i>
            <i class="green check icon" v-if="notification.data.status == 'processed'"></i>
            <i class="red cancel icon" v-if="notification.data.status == 'failure'"></i>
        </div>

        <div class="content">
            <div class="summary">
                {{ parsed_notification.target }}{{ parsed_notification.action }}{{ parsed_notification.status }}
                <div class="date">
                    {{ human_datetime_text }}
                </div>
            </div>
            <div class="extra text" v-html="parsed_notification.message">
            </div>
            <div class="meta">
                <a class="like" v-if="is_disabled">
                    <i class="red eye slash icon"></i>已過期
                </a>
                <a class="like" v-else @click="toggle_is_read()">
                    <i class="eye icon"></i> {{ notification.is_read ? '已讀':'未讀' }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        notification: Object,
    },
    data() {
        return {
            is_disabled: false,
            human_datetime_text: "",
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
        this.is_disabled = this.check_is_disabled()
        this.human_datetime_text = this.human_datetime(this.notification.created_at, null, "relative")
        setInterval(() => {
            this.is_disabled = this.check_is_disabled()
            this.human_datetime_text = this.human_datetime(this.notification.created_at, null, "relative")
            this.$forceUpdate()
        }, 1000*60)
    },
    computed: {
        parsed_notification() {
            let parsed_notification = {}
            let data = this.notification.data
            switch (data.target) {
                case "operation": {
                    parsed_notification.target = "訂單"
                    switch (data.action) {
                        case "create": {
                            parsed_notification.action = "建立"
                            switch (data.status) {
                                case "processing": {
                                    parsed_notification.status = "中"
                                    parsed_notification.message = "訂單建立中，建立完成後於此顯示結果"
                                    break
                                }
                                case "processed": {
                                    parsed_notification.status = "完成"
                                    parsed_notification.message = "訂單建立成功，訂單編號：<a>N4160755219144420983</a>"
                                    break
                                }
                                case "failure": {parsed_notification.action = "建立失敗"}
                                default: {}
                            }
                            break
                        }
                        case "core_waybills_process_intermodal": {
                            parsed_notification.action = "聯運"
                            switch (data.status) {
                                case "processing": {
                                    parsed_notification.status = "中"
                                    parsed_notification.message = "執行聯運中，完成後將於此顯示結果"
                                    break
                                }
                                case "processed": {
                                    parsed_notification.status = "完成"
                                    parsed_notification.message = "執行聯運成功"
                                    break
                                }
                                case "failure": {parsed_notification.action = "聯運執行失敗"}
                                default: {}
                            }

                            if (data.operation_number && data.operation_identity) {
                                parsed_notification.message += "，訂單：<a href=/provider/operations/edit/" + data.operation_identity + ">" + data.operation_number + "</a>"
                            }
                            break
                        }
                        case "update": {
                            break
                        }
                        case "delete": {
                            break
                        }
                        default: {

                        }
                    }
                    break
                }
                case "core_waybill": {
                    parsed_notification.target = "運單"
                    switch (data.action) {
                        case "create": {
                            break
                        }
                        case "update": {
                            break
                        }
                        case "delete": {
                            break
                        }
                        case "export": {
                            parsed_notification.action = "報表建立"
                            switch (data.status) {
                                case "processing": {
                                    parsed_notification.status = "中"
                                    parsed_notification.message = "報表建立中，建立完成後將於此顯示結果"
                                    break
                                }
                                case "processed": {
                                    parsed_notification.status = "完成"
                                    parsed_notification.message = "報表建立成功，下載連結：<a href='" + data.file_url + "'>" + data.filename + "</a>"
                                    break
                                }
                                case "failure": {parsed_notification.action = "建立失敗"}
                                default: {}
                            }
                            break
                        }
                        case "filter": {
                            parsed_notification.action = "查詢運單"
                            switch (data.status) {
                                case "processing": {
                                    parsed_notification.status = "中"
                                    parsed_notification.message = "運單查詢中，查詢完成將後於此顯示結果"
                                    break
                                }
                                case "processed": {
                                    let uri = ""
                                    let params = ""
                                    try {
                                        params = JSON.parse(data.params)
                                        if (params) {
                                            delete params.controller
                                            delete params.is_async
                                            delete params.action
                                            params.search_cache_key = data.search_cache_key
                                            params = object_to_query(params) || ""
                                            params = params.replace(/%25/gi,'').replace(/]/gi,'').replace(/\[/gi,'_')
                                        }
                                    } catch (e) {
                                        console.log(e);
                                    }
                                    parsed_notification.status = "完成"
                                    switch (data.scope) {
                                        case "provider": {
                                            this.$store.commit('provider/core_waybills_module/set_search_cache_key', data.search_cache_key);
                                            parsed_notification.message = `運單查詢成功，共有 ${data.amount} 筆資料`
                                            if (data.amount > 0) {
                                                let uri = '/provider/core_waybills' + "?" + params
                                                let a_element_params = this.is_disabled ? '' : `href=${uri} target="_blank"`
                                                parsed_notification.message += `，可以 <a ${a_element_params}>檢視</a> 或是於查詢欄匯出報表`
                                            } else {
                                                parsed_notification.message += `。`
                                            }
                                            break
                                        }
                                        case "customer": {
                                            this.$store.commit('customer/core_waybills_module/set_search_cache_key', data.search_cache_key);
                                            parsed_notification.message = `運單查詢成功，共有 ${data.amount} 筆資料`
                                            if (data.amount > 0) {
                                                parsed_notification.message += `，可以 <a>檢視</a> 或是於查詢欄匯出報表`
                                            } else {
                                                parsed_notification.message += `。`
                                            }
                                            break
                                        }
                                    }
                                    break
                                }
                                case "failure": {parsed_notification.action = "建立失敗"}
                                default: {}
                            }
                            break
                        }
                        default: {

                        }
                    }
                    break
                }
                default: {

                }
            }
            return parsed_notification
        },
    },
    methods: {
        toggle_is_read() {
            this.notification.is_read = true
        },
        update_notification() {
            this.$store.commit('provider/update_notification', this.notification)
        },
        check_is_disabled() {
            let data = this.notification.data
            if (!this.notification.created_at) return false
            if (data.target != "core_waybill") return false
            if (data.action != "filter") return false
            if (data.status != "processed") return false

            var ONE_MIN = 1000 * 60; // 1分鐘的毫秒數
            var Date_A = new Date(this.notification.created_at);
            var Date_B = new Date();

            var diff = Date_B - Date_A;
            if (diff > 0) {
                var minutes = Math.floor(diff/ONE_MIN);
                if(minutes > 30) return true
            }
            return false
        },
    },
    components: {
    }
}
</script>

<style scoped>
    .event.disabled {

    }
</style>
